import React from 'react';

const CompanyStatusIndicator = ({ statusEmpresas, className = '' }) => {
  if (!statusEmpresas) return null;

  const { com_dados, sem_dados, com_erro, resumo } = statusEmpresas;

  return (
    <div className={`rounded-lg border border-white/10 bg-white/5 shadow-[0_4px_12px_rgba(0,0,0,0.14)] backdrop-blur p-4 ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-slate-100">
          Status das Empresas
        </h3>
        <div className="text-sm text-slate-400">
          {resumo.com_dados + resumo.sem_dados + resumo.com_erro} empresas
        </div>
      </div>

      <div className="space-y-3">
        {/* Empresas com dados */}
        {com_dados.length > 0 && (
          <div className="flex items-center space-x-2">
            <svg className="h-5 w-5 text-emerald-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-sm font-medium text-emerald-200">
              {resumo.com_dados} empresas com dados
            </span>
            <div className="flex flex-wrap gap-1 ml-2">
              {com_dados.map((empresa, index) => (
                <span
                  key={index}
                  className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-emerald-500/20 text-green-800"
                >
                  {empresa.nome}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Empresas sem dados */}
        {sem_dados.length > 0 && (
          <div className="flex items-center space-x-2">
            <svg className="h-5 w-5 text-amber-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
            <span className="text-sm font-medium text-amber-200">
              {resumo.sem_dados} empresas sem dados
            </span>
            <div className="flex flex-wrap gap-1 ml-2">
              {sem_dados.map((empresa, index) => (
                <span
                  key={index}
                  className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-amber-500/20 text-yellow-800"
                  title={empresa.motivo}
                >
                  {empresa.nome}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Empresas com erro */}
        {com_erro.length > 0 && (
          <div className="flex items-center space-x-2">
            <svg className="h-5 w-5 text-rose-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-sm font-medium text-rose-200">
              {resumo.com_erro} empresas com erro
            </span>
            <div className="flex flex-wrap gap-1 ml-2">
              {com_erro.map((empresa, index) => (
                <span
                  key={index}
                  className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-rose-500/20 text-red-800"
                  title={empresa.erro}
                >
                  {empresa.nome}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Resumo estatístico */}
        <div className="pt-3 border-t border-white/10">
          <div className="grid grid-cols-3 gap-4 text-center">
            <div>
              <div className="text-2xl font-bold text-emerald-300">{resumo.com_dados}</div>
              <div className="text-xs text-slate-400">Com dados</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-amber-300">{resumo.sem_dados}</div>
              <div className="text-xs text-slate-400">Sem dados</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-rose-300">{resumo.com_erro}</div>
              <div className="text-xs text-slate-400">Com erro</div>
            </div>
          </div>
        </div>

        {/* Aviso se todas as empresas estão sem dados */}
        {resumo.com_dados === 0 && resumo.sem_dados > 0 && (
          <div className="mt-3 p-3 bg-amber-500/10 border border-amber-400/30 rounded-md">
            <div className="flex items-center">
              <svg className="h-5 w-5 text-amber-300 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div className="text-sm text-amber-200">
                <strong>Atenção:</strong> Todas as empresas estão retornando dados zerados. 
                Verifique a conectividade com o N8N ou a configuração das empresas.
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyStatusIndicator;

